module.exports = __webpack_public_path__ + "static/media/11NEPAD5.548f8e7c.jpg";